import axios from 'axios';

const url = '/jobsearch/api/job-analytics';

export const getTopSkillsAndJobTitles = (payload: any) =>
  axios.post(`${url}/top-skills-jobtitles`, payload);

export const getCandidateTopSkillsAndJobTitles = (payload: any) =>
  axios.post(`candidatesearch/api/candidate-analytics/top-skills-jobtitles`, payload);
